import { ModernSelectOption } from 'src/components/ModernSelect';
import { ICalcomEventType } from '../../types';

export const buildEventTypeOptions = (
  eventTypes: ICalcomEventType[]
): ModernSelectOption[] => {
  return eventTypes.map((eventType: ICalcomEventType) => ({
    value: String(eventType.id),
    label: `${eventType.title} (${eventType.lengthInMinutes} min)`,
  }));
};

export const findEventTypeOption = (
  options: ModernSelectOption[],
  eventTypeId: number
): ModernSelectOption | null => {
  return (
    options.find(
      (option: ModernSelectOption) => option.value === String(eventTypeId)
    ) ?? null
  );
};